import React from "react";
import "./index.css";

const Scrolling = ({ children }) => {
  return <div className="scroll">{children}</div>;
};

export default Scrolling;
